var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpUserguide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.93 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-help-userguide") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.52,22.24A.52.52,0,0,0,1,21.72a1.55,1.55,0,0,1,3.1,0,.52.52,0,1,0,1,0,2.59,2.59,0,0,0-5.17,0,.52.52,0,0,0,.52.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.52,19.14A.52.52,0,0,0,1,18.62a1.55,1.55,0,0,1,3.1,0,.52.52,0,0,0,1,0,2.59,2.59,0,0,0-5.17,0,.52.52,0,0,0,.52.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.52,16A.52.52,0,0,0,1,15.52a1.55,1.55,0,0,1,3.1,0,.52.52,0,1,0,1,0,2.59,2.59,0,0,0-5.17,0A.52.52,0,0,0,.52,16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.52,12.93A.52.52,0,0,0,1,12.41a1.55,1.55,0,0,1,3.1,0,.52.52,0,0,0,1,0,2.59,2.59,0,0,0-5.17,0,.52.52,0,0,0,.52.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,9.31a1.55,1.55,0,0,1,3.1,0,.52.52,0,1,0,1,0A2.59,2.59,0,0,0,0,9.31a.52.52,0,1,0,1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.9,27.93a1,1,0,0,1-1,1H23.28V1h2.59a1,1,0,0,1,1,1Zm-6.72-5.17h-3.1a.52.52,0,1,1,0-1h3.1a.52.52,0,1,1,0,1Zm-10.34,1h1a.52.52,0,0,1,0,1h-1a.52.52,0,1,1,0-1Zm10.34,0a.52.52,0,1,1,0,1H12.93a.52.52,0,0,1,0-1ZM9.83,21.72H15a.52.52,0,0,1,0,1H9.83a.52.52,0,1,1,0-1Zm10.34-4h-3.1a.52.52,0,1,1,0-1h3.1a.52.52,0,1,1,0,1Zm-10.34,1h1a.52.52,0,0,1,0,1h-1a.52.52,0,1,1,0-1Zm10.34,0a.52.52,0,1,1,0,1H12.93a.52.52,0,0,1,0-1ZM9.83,16.72H15a.52.52,0,0,1,0,1H9.83a.52.52,0,1,1,0-1Zm10.34-11h-3.1a.52.52,0,1,1,0-1h3.1a.52.52,0,1,1,0,1Zm-10.34,1h1a.52.52,0,0,1,0,1h-1a.52.52,0,1,1,0-1Zm10.34,0a.52.52,0,1,1,0,1H12.93a.52.52,0,0,1,0-1ZM9.83,4.72H15a.52.52,0,0,1,0,1H9.83a.52.52,0,1,1,0-1Zm10.34,6h-3.1a.52.52,0,1,1,0-1h3.1a.52.52,0,1,1,0,1Zm-10.34,1h1a.52.52,0,0,1,0,1h-1a.52.52,0,1,1,0-1Zm10.34,0a.52.52,0,1,1,0,1H12.93a.52.52,0,0,1,0-1ZM9.83,9.72H15a.52.52,0,0,1,0,1H9.83a.52.52,0,1,1,0-1ZM25.86,0H2.59a.52.52,0,0,0-.52.52V3.67A2.59,2.59,0,0,0,0,6.21a.52.52,0,0,0,1,0,1.55,1.55,0,0,1,3.1,0,.52.52,0,0,0,1,0A2.59,2.59,0,0,0,3.1,3.67V1H6.72V29H3.1V25.34a.52.52,0,0,0-1,0v.94a1.55,1.55,0,1,1,2.07-1.46.52.52,0,0,0,1,0,2.59,2.59,0,1,0-3.1,2.53v2.12a.52.52,0,0,0,.52.52H25.86a2.07,2.07,0,0,0,2.07-2.07V2.07A2.07,2.07,0,0,0,25.86,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpUserguide);
export default __webpack_public_path__ + "static/media/icon-help-userguide.c95d2c6c4caf192286164fd412664572.svg";
export { ForwardRef as ReactComponent };